class BundleCardProduct extends HTMLElement {
    constructor() {
        super();
        this.isMobile = window.innerWidth < 1024;
        this.bundleId = this.dataset.bundleId;
    }

    connectedCallback() {
        this.setListeners();
        this.restoreActiveBundle();
        if (!this.isMobile) return;

        this.swiper = new Swiper(this.querySelector('.swiper-container'), {
            slidesPerView: 'auto',
            spaceBetween: 0,
        });
    }

    restoreActiveBundle() {
        this.bundles = JSON.parse(sessionStorage.getItem('bundleProducts')) || {};
        if (Object.keys(this.bundles).length == 0) return;

        const currentBundle = this.bundles[this.bundleId]
        currentBundle.forEach(selection => {
            if (selection.index != this.dataset.index) return;

            this.querySelectorAll('[data-sibling-radio]').forEach(sibling => {
                if (sibling.value == selection.product.id) sibling.click()
            });

            setTimeout(() => {
                this.querySelectorAll('[data-variants-radio]').forEach(variant => {
                    if (variant.dataset.variantId == selection.variant) variant.click();
                })
            }, 350)
        })
    }

    setListeners() {
        this.setSiblingsListener();
        this.setVariantsListener();
    }

    setSiblingsListener() {
        const radios = this.querySelectorAll("[data-sibling-radio]");
        radios.forEach((radio) => {
            radio.addEventListener("change", async (event) => {
                const productHandle = event.target.getAttribute("data-product-handle");
                const newPrice = this.querySelector(
                    `[data-sibling-price][data-product-handle="${productHandle}"]`
                );

                const response = await fetch(
                    window.Shopify.routes.root + `/products/${productHandle}?view=bundle-product`
                );
                const responseText = await response.text();
                const html = new DOMParser().parseFromString(responseText, "text/html");

                const newInfo = html.querySelector("[data-product-info]");
                const newImage = html.querySelector("[data-product-image]");


                if (newInfo) this.querySelector("[data-product-info]").innerHTML = newInfo.innerHTML;
                if (newImage) this.querySelector("[data-product-image]").innerHTML = newImage.innerHTML;

                const livePrice = this.querySelector("[data-product-price]");
                if (livePrice && newPrice) {
                    livePrice.innerHTML = newPrice.innerHTML;
                }

                const bundleObj = {
                    index: this.dataset.index,
                    type: this.dataset.productType
                };

                this.querySelectorAll('[data-current-size]').forEach(currentSize => currentSize.innerHTML = '');
                publish(PUB_SUB_EVENTS.bundleSiblingChange, bundleObj)
                this.setVariantsListener()
            });
        });
    }

    setVariantsListener() {
        const variantsRadios = this.querySelectorAll("[data-variants-radio]");
        variantsRadios.forEach((radio) => {
            radio.addEventListener('change', (event) => {

                let product = JSON.parse(this.querySelector('[data-current-product]').innerHTML);
                product.color = event.target.dataset.color;
                product.variants.forEach(variant => {
                    if (variant.id == event.target.dataset.variantId) product.variant = variant;
                });
                const bundleObj =
                {
                    index: this.dataset.index,
                    product: product,
                    variant: event.target.dataset.variantId,
                    type: this.dataset.productType
                };

                this.querySelectorAll('[data-current-size]').forEach(currentSize => currentSize.innerHTML = event.target.value);
                publish(PUB_SUB_EVENTS.addToBundle, bundleObj)

            })
        })

        subscribe(PUB_SUB_EVENTS.bundleSiblingChange, (payload) => {
            if (this.dataset.index != payload.index) return;

            variantsRadios.forEach((radio) => {
                radio.checked = false;
            })
        })
    }
}
customElements.define("bundle-card-product", BundleCardProduct);



class BundlePreview extends HTMLElement {
    constructor() {
        super();
        this.discountPercentage = this.dataset.discountPercentage;
        this.bundleId = this.dataset.productId;
        this.bundleList = this.querySelector('[data-bundle-list]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[data-add-to-cart]');

        this.submitButton.addEventListener('click', () => this.addBundleToCart());
    }

    connectedCallback() {
        this.createProducts();
        subscribe(PUB_SUB_EVENTS.addToBundle, (payload) => {
            this.addToSessionStorage(payload);
            this.handleAddProduct(payload);
            if (this.dataset.maxProducts == this.getProducts().length)
                this.openPreview()
            this.checkButtonState();
        });

        subscribe(PUB_SUB_EVENTS.bundleSiblingChange, (payload) => {
            this.removeFromSessionStorage(payload);
            this.handleRestablishPlaceholder(payload);
            this.recalcTotal();
            this.recalcProductCount();
            this.checkButtonState();
        });

        this.setPreviewHeight();
        window.addEventListener('resize', () => this.setPreviewHeight());

        this.setRemoveListener();
    }

    checkButtonState() {
        const productsLength = this.querySelectorAll('[data-variant-id][data-index]').length || 0;
        this.submitButton.disabled = !(parseInt(this.dataset.maxProducts) === productsLength);
    }

    setRemoveListener() {
        this.querySelectorAll('[data-remove-product]').forEach(btn => {
            btn.addEventListener('click', (event) => {
                const eventObj = { index: btn.dataset.bundleIndex, type: btn.dataset.productType }
                publish(PUB_SUB_EVENTS.bundleSiblingChange, eventObj)
            })
        })
    }

    createProducts() {
        const currentProds = this.getProducts();
        currentProds.forEach(payload => this.handleAddProduct(payload));
    }

    getBundleProductsObject() {
        return JSON.parse(sessionStorage.getItem('bundleProducts')) || {};
    }

    getProducts() {
        const bundleObj = this.getBundleProductsObject();
        return bundleObj[this.bundleId] || [];
    }

    addToSessionStorage(payload) {
        const bundleObj = this.getBundleProductsObject();
        const bundleKey = this.bundleId;
        let currentProds = bundleObj[bundleKey] || [];
        if (currentProds.find(prod => prod.index === payload.index)) {
            currentProds = currentProds.map(prod => {
                if (prod.index === payload.index) {
                    return payload;
                }
                return prod;
            });
        } else {
            currentProds.push(payload);
        }
        bundleObj[bundleKey] = currentProds;
        sessionStorage.setItem('bundleProducts', JSON.stringify(bundleObj));
    }

    removeFromSessionStorage(payload) {
        const bundleObj = this.getBundleProductsObject();
        let currentProds = this.getProducts();

        bundleObj[this.bundleId] = currentProds.filter(prod => prod.index !== payload.index);
        sessionStorage.setItem('bundleProducts', JSON.stringify(bundleObj));
    }

    setPreviewHeight() {
        let maxHeight = 0;
        const bundleFooter = this.querySelector('[data-bundle-footer]').offsetHeight;
        const bundleHeader = this.querySelector('[data-bundle-header]').offsetHeight;

        maxHeight = window.innerHeight - bundleFooter - bundleHeader - (window.matchMedia('(min-width: 1024px)').matches ? 60 : 80);
        document.documentElement.style.setProperty('--bundle-drawer-content-height', `${maxHeight || 0}px`);

    }

    recalcTotal() {
        const products = Array.from(this.querySelectorAll('[data-index]'));
        let total = 0;
        products.forEach(prod => total += parseInt(prod.dataset.productPrice));
        const discountedTotal = total - (total * this.discountPercentage / 100);

        this.querySelector('[data-total]').innerHTML = total == 0 ? null : Shopify.formatMoney(total, window.priceFormat.moneyWithoutCurrency);
        this.querySelector('[data-discounted-total]').innerHTML = total == 0 ? null : Shopify.formatMoney(discountedTotal, window.priceFormat.moneyWithoutCurrency);

    }

    handleRestablishPlaceholder(payload) {
        if (typeof payload === 'undefined') return;
        this.recalcTotal();
        const prevProd = this.bundleList.querySelector(`[data-index="${payload.index}"]`);
        const newProd = this.createPlaceholderTemplate(payload);
        prevProd.replaceWith(newProd);
    }

    handleAddProduct(payload) {
        const prevProd = this.bundleList.querySelector(`[data-index="${payload.index}"]`);
        const newProd = this.createVariantTemplate(payload);
        prevProd.replaceWith(newProd);
        this.recalcTotal();
        this.recalcProductCount();
        this.setRemoveListener();
    }

    recalcProductCount() {
        this.querySelectorAll('[data-product-count]').forEach(counter => counter.innerHTML = this.getProducts().length)
    }

    async addBundleToCart() {
        const variants = Array.from(this.bundleList.querySelectorAll('[data-variant-id][data-index]'));
        this.submitButton.classList.add('loading');

        const date = Date.now();
        const formData = {
            items: variants.map(prod => {
                return {
                    id: parseInt(prod.dataset.variantId),
                    quantity: 1,
                    properties: {
                        '_bundleId': `${this.bundleId}||${date}`
                    }
                };
            })
        };

        if (this.cart) {
            formData['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
            formData['sections_url'] = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
        }

        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        const result = await response.json();

        if (!response.ok) {
            console.log('error', result)
            this.handleErrorMessage(result.message);
            this.submitButton.classList.remove('loading');
            return;
        }
        this.submitButton.classList.remove('loading');

        this.cart.renderContents(result, {
            source: 'product-form',
            productVariantId: this.bundleId,
        });
    }


    createPlaceholderTemplate(payload) {

        const template = `
        <div data-index="${payload.index}" data-product-price="0"
             class="tw-flex tw-flex-row tw-gap-12">
            <div
                class="tw-bg-lgrey tw-border-dashed tw-border-1 tw-border-lgrey5 lg:tw-h-full tw-w-full tw-flex-[0_0_34%] tw-aspect-[98/130] tw-rounded-4">
            </div>
            <div class="tw-h-[6rem] lg:tw-h-full">
                <div class="tw-font-2xs-primary tw-text-black tw-uppercase">
                      ${window.bundleStrings.select} ${payload.type}
                </div>
            </div>
        </div> `;
        const parser = new DOMParser();
        const parsedHTML = parser.parseFromString(template, 'text/html');

        return parsedHTML.querySelector('div');

    }

    createVariantTemplate(payload) {
        const selectedProduct = payload.product;
        const template = `
            <div data-index="${payload.index}" data-product-price="${selectedProduct.price}" data-variant-id="${selectedProduct.variant.id}" class="tw-flex tw-flex-row tw-gap-12">
                <div class="tw-w-full lg:tw-h-full tw-flex-[0_0_34%] tw-aspect-[98/130]">
                    <img class="tw-rounded-4" src="${selectedProduct.featured_image}&width=640" alt="${selectedProduct.title}" srcset="${selectedProduct.featured_image}&width=320, ${selectedProduct.featured_image}&width=640 2x"/>
                </div>
                      <div class=" tw-h-[6rem] lg:tw-h-full tw-w-full ">
                        <div class="tw-w-full tw-flex tw-h-full tw-items-start tw-flex-col tw-justify-start tw-gap-16">
                            <p class="tw-font-2xs-primary tw-text-black tw-uppercase "> ${selectedProduct.title}</p>
                            <div class="tw-flex tw-flex-col [&_span]:tw-leading-[1]">
                                <span>
                                    <span class="tw-font-xs-secondary tw-text-black">${window.bundleStrings.color}:</span>
                                    <span class="tw-font-xs-secondary-light tw-text-darkgrey ">${selectedProduct.color}</span>
                                </span>
                                <span>
                                    <span class="tw-font-xs-secondary tw-text-black">${window.bundleStrings.size}:</span>
                                    <span class="tw-font-xs-secondary-light tw-text-darkgrey ">${selectedProduct.variant.option1}</span>
                                </span>
                            </div>
                            <button class="tw-pt-14" data-remove-product data-bundle-index="${payload.index}" data-product-type="${payload.type}">
                                <span class="tw-capitalize tw-font-xs-secondary-light tw-text-darkgrey">remove</span>
                            </button>
                       </div>
                      </div>
            </div>`;

        const parser = new DOMParser();
        const parsedHTML = parser.parseFromString(template, 'text/html');

        return parsedHTML.querySelector('div');
    }


    handleErrorMessage(errorMessage = false) {
        const errorWrapper = this.querySelector('[data-error-message-wrapper]');
        if (!errorWrapper) return

        errorWrapper.querySelector('[data-error-message]').innerHTML = errorMessage;
        errorWrapper.removeAttribute('hidden');
    }

    openPreview() {
        this.querySelector('details').setAttribute('open', true);
    }

}

customElements.define('bundle-preview', BundlePreview);
